<template>
<grid class="social-login" flat>
	<grid-item size="1/3">
		<span>
			OR LOGIN WITH...
		</span>
	</grid-item>
	<grid-item size="1/3">
		<a>
			<img src="@/assets/images/google.png" alt="google" class="icon">
			GOOGLE
		</a>
	</grid-item>
	<grid-item size="1/3">
		<a>
			<img src="@/assets/images/linkedin.png" alt="linkedin" class="icon">
			LINKEDIN
		</a>
	</grid-item>
</grid>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.social-login {
	width: 80%;
	margin: 0 auto;
	display: inline-flex;

	.icon {
		width: 32px;
		float: left;
		margin: 0px 5px;
	}
	span, a {
		color: #fff;
		float: left;
		font-size: 13px;
		font-weight: 400;
		line-height: 35px;
		border-bottom: none !important;

	}
}
</style>
